export default "__VITE_ASSET__CqYRfUx7__"